import { Link } from "react-router-dom";
import { LogoIcon } from "../../../icons";
import AccountActionMenu from "../../Common/AccountActionMenu";
import { accountTeamRoleList } from "../../../common/utils";

const MyOrgItem = props => {
  const { orgItem } = props;

  return (
    <div className="events-page-myorg-content-row-box">
      <Link
        to={`/company/${orgItem?.orgSlug}`}
        className="events-page-myorg-content-row-box-logo"
        style={{
          backgroundColor: orgItem?.orgLogoColor ? orgItem?.orgLogoColor : "",
        }}
      >
        {orgItem?.orgLogo ? (
          <img src={orgItem?.orgLogo} alt="logo" />
        ) : (
          <LogoIcon />
        )}
      </Link>
      <div className="events-page-myorg-content-row-box-info">
        <Link
          to={`/company/${orgItem?.orgSlug}`}
          className="events-page-myorg-content-row-box-info-name"
        >
          {orgItem?.orgName}
        </Link>
        {orgItem?.teams?.[0]?.role ? (
          <div className="events-page-myorg-content-row-box-info-role">
            {accountTeamRoleList?.[orgItem?.teams?.[0]?.role]?.name}
          </div>
        ) : orgItem?.isRole ? (
          <div className="events-page-myorg-content-row-box-info-role">
            {accountTeamRoleList?.[orgItem?.isRole]?.name}
          </div>
        ) : null}

        {orgItem?.isLoggedWith ? (
          <div className="events-page-myorg-content-row-box-info-current">
            Selected
          </div>
        ) : null}
      </div>
      <div className="events-page-myorg-content-row-box-action">
        <AccountActionMenu accountId={orgItem?.accountId} />
      </div>
    </div>
  );
};

export default MyOrgItem;
